var SCM = SCM || {};

SCM.SearchResults = {};

SCM.SearchResults.defaults = {
    controller: 'Solr',
    action: 'SolrSearch',
    instanceName: 'Search',
    baseSiteUrl: '',
    updateTargetSelector: '#divSearch'
};

$(function () {

    $('#searchResultsPage').on('click', '.journal-description-container a', function (e) {
        e.preventDefault();
        $(this).closest('.journal-description-container').find('.journal-description').toggleClass('hide');
    });

    function toggleTaxonomyChildren() {
        $('.js-taxonomy-parent-arrow').on('click', function () {
            var $this = $(this);

            let $taxonomyChildList = $this.parents('.js-taxonomy-label-wrap').siblings('.js-taxonomy-child-list');
            $taxonomyChildList.toggleClass('hide');

            let $taxonomyInput = $this.parents('.js-taxonomy-label-wrap').find('.js-taxonomy-checkbox, a.js-taxonomy-label');

            if ($taxonomyChildList.hasClass('hide')) {
                $taxonomyInput.attr('aria-expanded', 'false');
            } else {
                $taxonomyInput.attr('aria-expanded', 'true');
            }

            var $icon = $this.children('.js-taxonomy-icon');
            var $screenReaderText = $icon.find('.screenreader-text');

            if ($icon.hasClass('icon-general-arrow-filled-right')) {
                $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
                $screenReaderText.text('Collapse');
            } else {
                $icon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
                $screenReaderText.text('Expand');
            }
        });

        // if taxonomy is already selected expand its parents
        if ($('.js-taxonomy-child-list .js-queryitem').length > 0) {
            $('.js-taxonomy-child-list .js-queryitem').parents('.js-taxonomy-child-list .js-taxonomy-child-list-item').each(function () {
                var $selectedElement = $(this).find('.js-queryitem');
                if ($selectedElement.length > 0) {
                    // expand this child list
                    var $arrowLink = $(this).find('.js-taxonomy-parent-arrow').first();
                    var $icon = $arrowLink.children('.js-taxonomy-icon');
                    if ($arrowLink && $arrowLink.length && $icon.hasClass('icon-general-arrow-filled-right')) {
                        $arrowLink.parents('.js-taxonomy-label-wrap').siblings('.js-taxonomy-child-list').toggleClass('hide');
                        $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
                    }
                }
            });
            $('.js-taxonomy-child-list').each(function () {
                if ($(this).find('.js-taxonomy-checkbox:checked').not(':visible').length > 0) {
                    $(this).find('.facetShowMore').click();
                }
            });


        }
    } // END: toggleTaxonomyChildren()

    function updateAvailabilityRedirectUrl($el, redirectUrl) {

        var $checkedFilters = $('.js-availability-chkbox:checked');
        var urlSearchParams = redirectUrl?.split('&');
        var allFiltersChecked = $checkedFilters.length === $('.js-availability-chkbox').length;

        // remove all the access parameters so we can start fresh
        var queryParams = urlSearchParams.filter(p => !p.startsWith('access'));

        if ($el.data('filterName') === 'access_all') {
            if ($el.is(':checked')) {
                queryParams.push('access_all=true')
            }
            redirectUrl = queryParams.join('&');
        }
        else { 
            if (allFiltersChecked) {
                queryParams.push('access_all=true')
            }
            else {
                // Only add the checked filters
                $.each($checkedFilters, function (idx, val) {
                    queryParams.push(`${$(this).data('filterName')}=true`);
                });
            }            
            redirectUrl = queryParams.join('&');
        }
        return redirectUrl;
    }

    toggleTaxonomyChildren(); // run the function when page loads (also called in doSolrSearch ajax below)

    var cache = {};
    //push the current state into the cache and into the history
    var initialQueryString = window.location.search.substring(1);


    window.onpopstate = function (e) {
        if (e.state) {
            SCM.SearchResults.doSolrSearch(e.state);
        }
    };

    SCM.PublicationDateFilter.init();

    SCM.Utilities.Brightcove.init();

    //bind actions
    (function() {
        var $updateTarget = $(SCM.SearchResults.defaults.updateTargetSelector);

        cache[initialQueryString] = { results: $updateTarget.html() };
        window.history.replaceState({ queryString: initialQueryString }, null, null);

        var isAlertPostCompleted = true;

        $updateTarget.on('click', '.js-edition-select', function (e) {
            var $inputEl = $(this).siblings('input');
            if ($inputEl.length) {
                var query = $inputEl.data('redirectUrl');
                if (query !== undefined) {
                    SCM.SearchResults.doSolrSearch({ queryString: query });
                }
            }
        });

        $updateTarget.on('click', '.chkSelect', function (e) {
            var $clickElement = $(this);
            var redirectUrl = $clickElement.data('redirectUrl');
            if ($clickElement.hasClass('availability')) {
                var redirectUrl = updateAvailabilityRedirectUrl($clickElement, redirectUrl);
            }
            
            SCM.SearchResults.doSolrSearch({ queryString: redirectUrl });
        });

        $updateTarget.on('click', '.js-sf-facet__link', function (e) {
            var url = $(this).attr('data-url');
            if (url && url !== '#' && url !== 'javascript:;') {
                e.preventDefault();

                SCM.SearchResults.doSolrSearch({ queryString: url });
            }
        });

        $updateTarget.on('click', '.js-close-button', function(e) {
            var url = $(this).attr('data-url');
            if (url != undefined && url !== '#' && url !== 'javascript:;') {
                e.preventDefault();

                SCM.SearchResults.doSolrSearch({ queryString: url });
            }
        });

        $updateTarget.on('click', '.rbShowFacet', function(e) {
            e.preventDefault();
            var previousStatus = $(this).attr('previous-status');
            if (previousStatus == 'False') {
                var dataurl = $(this).attr('data-url');
                SCM.SearchResults.doSolrSearch({ queryString: dataurl });
            }
        });

        $updateTarget.on('click', '#solrSearchBtn', function(e) {
            var queryText = $('#txtSearch').val();

            if (!queryText || queryText === '') {
                alert('Please enter a term to perform search');
            } else {
                queryText = encodeURIComponent(queryText);
                SCM.SearchResults.doSolrSearch({ queryString: 'q=' + queryText });
            }
        });

        // Publication Date Filter
        $updateTarget.on('click', '#btnRangeSearch', function(e) {
            var fromYear = parseInt(SCM.PublicationDateFilter.$fromYear.val());
            var toYear = parseInt(SCM.PublicationDateFilter.$toYear.val());
            var fromMonth = parseInt(SCM.PublicationDateFilter.$fromMonth.val());
            var toMonth = parseInt(SCM.PublicationDateFilter.$toMonth.val());
            var validationResponse = '';

            // Record all the date types we can select so we can clear the previous query params below
            var dateTypesToRemoveFromPrevQuery = $('.js-date-type-chk').map(function () {
                return $(this).val();
            });
            // find out what's checked
            // we have a hidden one because Published also assumes PublishedElectronic, so have to add both
            // PublishedElectronic is a hidden field that is automatically checked when published is checked
            var $filtersChecked = $('.js-date-type-chk:checked, .js-date-type-chk:hidden:checked');
            
            if (SCM.PublicationDateFilter.isSingleDateSelected) {
                validationResponse = SCM.PublicationDateFilter.getValidationResponseTextForSingleDate(fromYear);
            } else {
                validationResponse = SCM.PublicationDateFilter.getValidationResponseTextForDateRange(fromYear, toYear, fromMonth, toMonth);
            }
            if (validationResponse && validationResponse.length) {
                // Uh-oh! User did something bad!
                $('.js-publication-date-filter-validation').text(validationResponse);
                $('#js-publication-date-filter-modal').foundation('reveal', 'open');
                return;
            }
           
            var dateValuesString = SCM.PublicationDateFilter.getSolrDateString(fromYear, toYear, fromMonth, toMonth);
            var dateFilterTypeString = '&dateFilterType=' + (SCM.PublicationDateFilter.isSingleDateSelected ? 'single' : 'range');
           
            var dateString;

            // If they only select the Updated date filter, remove articleDate from the query 
            // since this date (versionDate) doesn't apply to articles  (NARN-12098)
            // and don't add the date values for articleDate to the query string
            if ($filtersChecked.length === 1 && $filtersChecked.val() === 'rg_VersionDate') {
                dateTypesToRemoveFromPrevQuery.push('rg_ArticleDate');
                dateString = dateFilterTypeString + '&' + $filtersChecked.val() + '=' + dateValuesString;
            }
            else {
                // keeping articleDate, so add the dateValues to the beginning which is added to articleDate later on
                dateString = dateValuesString + dateFilterTypeString;
                var $filtersToUse = $filtersChecked;
                // if none are checked, use all filters (NARN-12098)
                if ($filtersChecked.length === 0) {
                    $filtersToUse = $('.js-date-type-chk');
                    // Adding this if no date types are selected so we know what to check/uncheck on return
                    // Behavior and query string is the same for both check all and check none
                    dateString += '&noDateTypes=true';
                }
               
                // Now build the rest of the query string based on the filters
                $filtersToUse.each(function () {
                    dateString += '&' + $(this).val() + '=' + dateValuesString;
                });
            }
            
            // get all the previous query params
            var queryParams = $(this).attr('data-url').split('&');
            // strip out date filter type and date types to filter to replace with new date string built above
            queryParams = $.grep(queryParams, function (param, idx) {
                var key = param.split('=')[0];
                // only return those params which are not dateFilterType and are not the date types
                return (key.indexOf('dateFilterType') < 0 && key.indexOf('noDateTypes') < 0 && $.inArray(key, dateTypesToRemoveFromPrevQuery) < 0);
            });
            // now join the remaining ones back together
            var searchUrl = queryParams.join('&');
            // if we still have articleDate=queryText, replace queryText with the dateString
            // which adds in the date range for articleDate plus datefiltertype and date types
            if (searchUrl.indexOf('queryText') >= 0) {
                searchUrl = searchUrl.replace('queryText', dateString);
            }
            else {
                // otherwise, just add on datefiltertype and date types (versionDate only)
                searchUrl += dateString;
            }

            SCM.SearchResults.doSolrSearch({ queryString: searchUrl });
        });
        
    }());

    function initFigureModalContainer(openModal, modalItemToOpen) {
        SCM.ArticleImageDetails.init('sr-item-image', openModal, modalItemToOpen);
    }
    initFigureModalContainer(false, '0');

    //add search functions to SCM.SearchResults
    SCM.SearchResults = $.extend(SCM.SearchResults, function ($, undefined) {

        var doSolrSearch = function (myobject) {

            /* The openModal section of code below is needed by SCM.SharedWidgets.ArticleImageDetails.js
             * to control opening the next or previous image modal after reloading search results for 
             * the next or previous page respectively.  The value of myobject.openModal indicates
             * which modal to open.  Typically, this will be 0 for the next page and the index of
             * the last image on the previous page (ex. 23 when 0 to 23 items are on a search page).
             * After completing the search ajax call, theopenModal state is passed to 
             * InitFigureModalContainer function which determines whether the image modal is 
             * opened. 
             */
            var openModal = false;
            var modalItemToOpen;
            if (myobject.openModal) {
                openModal = true;
                modalItemToOpen = myobject.openModal;
            }
            var settings = $.extend(SCM.SearchResults.defaults, myobject);

            // only trigger it on search result page (still not ideal to assume that hash tag is always for search though)
            var searchUrlPatt = /\/(search-results|advanced-search)\/?$/i;
            if (!searchUrlPatt.test(location.pathname) &&
                !settings.isNbnj) {
                return;
            }

            var advancedSearchUrlPattern = /\/advanced-search\/?$/i;
            if (advancedSearchUrlPattern.test(location.pathname)) {
                // User is on the Advanced Search page. Redirect to the Search Results page
                var newUrl = '/search-results';
                if (settings.baseSiteUrl) {
                    newUrl = '//' + settings.baseSiteUrl + newUrl;
                }
                newUrl += '?' + myobject.queryString;
                window.location = newUrl;
                return;
            }

            var $updateTarget = $(settings.updateTargetSelector);

            if (cache[myobject.queryString] && !settings.isNbnj) {
                if (!myobject.cacheSearchWithoutUpdatingDom) {
                    //no need hit the server, we've run the query before in the context of this page
                    $updateTarget.html(cache[myobject.queryString].results).show();
                    //need to rebind things that would normally rebind after the ajax post
                    SCM.SolrSearch.ajaxComplete();

                   
                    bindObjectsOnUpdate(myobject, $updateTarget);
                    initFigureModalContainer(openModal, modalItemToOpen);
                }
                // re-run the brightcove script to rebuild thumbnails for video
                // but only if there is video on the page!
                if ($('.video-js').length) {
                    SCM.Utilities.Brightcove.init();
                }
                return;
            }

            // change instance name if image tab is showing and add image tab query string if not already there
            var imageTabActive = false;
            var multimediaGalleryQueryStringValue = SCM.JSUtility.getSearchParamByName('mg');
            if (multimediaGalleryQueryStringValue) {
                imageTabActive = multimediaGalleryQueryStringValue.toLowerCase() === 'true';
            }
            if (imageTabActive) {
                settings.instanceName = 'OUP_SearchResults_MG';
                if (myobject.queryString !== null) {
                    if (!(myobject.queryString.toLowerCase().indexOf('mg=true') > 0)) {
                        myobject.queryString = myobject.queryString + '&mg=true';
                    }
                }
            }

            // Default back to Page 1 when the search has changed
            var page = SCM.JSUtility.getSearchParamByName('page');
            if (page && parseInt(page) !== 1) {
                myobject.queryString = myobject.queryString.replace('page=' + page, 'page=1');
            }

            var ajaxUrl = '/' + settings.controller + '/' + settings.action + '/' + settings.instanceName;
            if (typeof settings.baseSiteUrl !== 'undefined' && settings.baseSiteUrl !== '') {
                ajaxUrl = '//' + settings.baseSiteUrl + ajaxUrl;
            }
            ajaxUrl += '?' + myobject.queryString;

            if (settings.isNbnj) {
                var bookId = $('#hfCurrentBookId').val();
                if (!ajaxUrl.includes('nbnjToc=true') && !ajaxUrl.includes('bookId=' + bookId)) {
                    ajaxUrl += '&bookId=' + bookId;
                }
            }

            if (myobject.functionToDoWhileAjaxLoading) {
                myobject.functionToDoWhileAjaxLoading(myobject.currentItem);
            }

            addSearchCover($('.info-inner-cover'));
            
            $.get(ajaxUrl).done(function (results) {
                if (!myobject.cacheSearchWithoutUpdatingDom) {
                    $updateTarget.html(results);
                }

                removeSearchCover($('.info-inner-cover'));

                cache[myobject.queryString] = {
                    results: results,
                    updateTargetSelector: settings.updateTargetSelector
                };

                if (!myobject.cacheSearchWithoutUpdatingDom) {
                    bindObjectsOnUpdate(myobject, $updateTarget);
                    initFigureModalContainer(openModal, modalItemToOpen);
                }
            })
                .fail(handleAjaxError)
                .always(function () {
                    if (myobject.functionToDoWhileAjaxLoading) {
                        myobject.functionToDoWhileAjaxLoading(myobject.currentItem);
                    }
                });

        }; // END: doSolrSearch(myobject)

        function addSearchCover($elementToCover) {
            $elementToCover.removeClass('uncovered');
            $elementToCover.addClass('covered');
        }

        function removeSearchCover($coveredElement) {
            $coveredElement.removeClass('covered');
            $coveredElement.addClass('uncovered');
        }

        function handleAjaxError(xmlHttpRequest, textStatus, errorThrown) {
            if (window.console) {
                console.error(errorThrown);
            }
        }

        // function to bind objects after ajax call to SOLR or retrieve results from cache
        function bindObjectsOnUpdate(myobject, $updateTarget) {
            
            App.SolrFacet.scrollIfNotInView($updateTarget[0]);
            
            // Below code is to retain the viewoption selected by client
            if (typeof clientViewOption !== 'undefined' && clientViewOption !== '') {
                var $sriExpandedView = $('.sri-expandedView');
                if (clientViewOption === 'Expanded') {
                    $sriExpandedView.show();
                } else {
                    $sriExpandedView.hide();
                }
            }


            App.SolrFacet.collapseFacets();
            toggleTaxonomyChildren();

            // verify if browser supports history.state before using - not supported in Edge
            if (window.history.state) {
                if (window.history.state.queryString != myobject.queryString) {
                    window.history.pushState(myobject,
                        null,
                        window.location.pathname + '?' + myobject.queryString);
                }
            }
            else {
                window.history.pushState(myobject,
                    null,
                    window.location.pathname + '?' + myobject.queryString);
            }

            javascriptInit();
        }

        // function to initialize all javascript needed when updating search
        function javascriptInit() {
            if (SCM.JournalCitationFilter) {
                SCM.JournalCitationFilter.init();
            }

            if (Theme.BookSectionEditors) {
                Theme.BookSectionEditors.init();
            }

            if (SCM.Toolbar) {
                SCM.Toolbar.init();
            }
        }

        return { doSolrSearch: doSolrSearch };
    }(jQuery));

});